import { AuthActions } from '../../actions/constant';
const { SUCCESS_SET_PASSWORD, FAILURE_SET_PASSWORD, RESET_SET_PASSWORD } =
  AuthActions;

const initialSetPasswordState: object = {
  isSetPassword: false,
  response: null,
};

export const setPasswordReducer = (
  state = initialSetPasswordState,
  action: any
) => {
  switch (action.type) {
    case SUCCESS_SET_PASSWORD: {
      return {
        ...state,
        isSetPassword: true,
        response: action.payload,
      };
    }

    case FAILURE_SET_PASSWORD:
      return {
        ...state,
        isSetPassword: false,
        response: action.payload,
      };

    case RESET_SET_PASSWORD:
      return initialSetPasswordState;

    default:
      return state;
  }
};
